import { Flex, Heading } from "@chakra-ui/react"
import MatrixBlockRenderer from "components/matrix/matrixBlockRenderer"
import Wrapper from "components/layout/wrapper"
import darkLightPageStyles from "styles/darkLightStyles"

export default function PageContent({
    page,
    matrix,
    site,
    user,
    colorMode = "dark",
    channels,
    craftSiteId,
    showPageHeader,
    sessionTypes, // Optional - for program-guide
    sessionId, // Optional - for program-guide
    presentationId, // Optional - for program-guide
    facetsConfig, // Optional - for program-guide
    children, // Optional - for pages passing children to Layout
    ad = null, // Optional - ad unit to interleave into the matrix blocks
    adPositionIndex = 0, // Optional - block index the ad is placed at (0 = above first block)
}) {
    const shouldShowHeader = showPageHeader !== undefined ? showPageHeader : page?.showPageHeader ?? true

    return (
        <Flex
            as="main"
            direction="column"
            width={"100%"}
            align="center"
            mb="60px"
            bg={darkLightPageStyles[colorMode].bgColor}
        >
            {shouldShowHeader ? (
                <Wrapper id="pageHeader" pt={["20px", "30px", "40px"]}>
                    <Heading
                        as="h1"
                        color={darkLightPageStyles[colorMode].pageTitleColor}
                        fontWeight="600"
                        dangerouslySetInnerHTML={{ __html: page?.title }}
                    />
                </Wrapper>
            ) : null}

            {children ? (
                children
            ) : (
                <MatrixBlockRenderer
                    blocks={matrix}
                    site={site}
                    user={user}
                    colorMode={colorMode}
                    channels={channels}
                    craftSiteId={craftSiteId}
                    sessionTypes={sessionTypes}
                    sessionId={sessionId}
                    presentationId={presentationId}
                    facetsConfig={facetsConfig}
                    ad={ad}
                    adPositionIndex={adPositionIndex}
                />
            )}
        </Flex>
    )
}
